export var BRAND_TYPE = "brand";